import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CYLINDO_OPTIONS, CYLINDO_ACCOUNT_ID, FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, PANTONE_FABRIC_CONFIG } from 'commons/constants';
import { orientationOptionIds } from 'components/consumer/OrientationPDPModal';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useCylindoDimensionShots from '../useCylindoDimensionShots';
import useCylindoCache from './cylindoCache/useCylindoCache';
import { DISABLED_UPHOLSTERY, EMPTY_ARRAY, EMPTY_OBJECT, SUNBRELLA_NAME_MISMATCH_OPTIONS, CYLINDO_FRAMES_TO_SHOW, CYLINDO_CONTENT_API } from './cylindoCache/defaults';
const usePDPCylindoViewer = t0 => {
  const $ = _c(41);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isPDPDesktop: t2,
    material: t3,
    deferCylindoFetch: t4
  } = t1;
  const isPDPDesktop = t2 === undefined ? false : t2;
  const material = t3 === undefined ? null : t3;
  const deferCylindoFetch = t4 === undefined ? false : t4;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t5
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t5;
  const productId = basicDetails?.id;
  const isCylindoProduct = !!basicDetails?.custom_properties?.cylindo_product;
  const {
    config: cylindoProductConfig,
    version: cylindoVersion,
    loading
  } = useCylindoCache(productId, isCylindoProduct, deferCylindoFetch);
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ...SUNBRELLA_NAME_MISMATCH_OPTIONS,
      ...PANTONE_FABRIC_CONFIG.pantoneFabricCylindoNameMapping
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const nameMismatchOptions = t6;
  let t7;
  if ($[3] !== cylindoProductConfig || $[4] !== material?.label || $[5] !== productId || $[6] !== selectedOptionsExtended) {
    t7 = () => {
      if (!productId || !cylindoProductConfig || !selectedOptionsExtended) {
        return null;
      }
      const upholsteryName = material?.label ?? selectedOptionsExtended[FABRIC_PRODUCT_OPTION_ID]?.value?.value ?? selectedOptionsExtended[LEATHER_PRODUCT_OPTION_ID]?.value?.value ?? null;
      if (!upholsteryName) {
        return null;
      }
      const correctedUpholsteryName = nameMismatchOptions[upholsteryName] || upholsteryName;
      return correctedUpholsteryName.trim().replace("\u2122", "").toUpperCase();
    };
    $[3] = cylindoProductConfig;
    $[4] = material?.label;
    $[5] = productId;
    $[6] = selectedOptionsExtended;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  material?.label;
  let t8;
  if ($[8] !== t7) {
    t8 = t7();
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const upholsteryKey = t8;
  const hasUpholsteryOption = !!upholsteryKey;
  let t9;
  if ($[10] !== cylindoVersion || $[11] !== upholsteryKey) {
    t9 = {
      upholsteryKey,
      cylindoVersion
    };
    $[10] = cylindoVersion;
    $[11] = upholsteryKey;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const dimensionShotsData = useCylindoDimensionShots(t9);
  let t10;
  bb0: {
    if (!upholsteryKey || DISABLED_UPHOLSTERY.includes(upholsteryKey)) {
      t10 = undefined;
      break bb0;
    }
    let t11;
    if ($[13] !== cylindoProductConfig.features || $[14] !== upholsteryKey) {
      const upholsteryFeature = cylindoProductConfig.features?.find(_temp);
      t11 = upholsteryFeature?.options.find(opt => opt.code?.toUpperCase() === upholsteryKey);
      $[13] = cylindoProductConfig.features;
      $[14] = upholsteryKey;
      $[15] = t11;
    } else {
      t11 = $[15];
    }
    const upholsteryOption = t11;
    if (!upholsteryOption) {
      t10 = undefined;
      break bb0;
    }
    let t12;
    if ($[16] !== upholsteryOption.code) {
      t12 = {
        [CYLINDO_OPTIONS.UPHOLSTERY]: upholsteryOption.code
      };
      $[16] = upholsteryOption.code;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    t10 = t12;
  }
  const upholsteryFeatureDetails = t10;
  const isUpholsteryFeatureAvailable = !!upholsteryFeatureDetails;
  const orientationId = orientationOptionIds.find(id => selectedOptionsExtended[id]);
  const orientationValue = selectedOptionsExtended[orientationId]?.value?.value;
  let t11;
  if ($[18] !== orientationValue) {
    t11 = orientationValue?.toUpperCase();
    $[18] = orientationValue;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const orientationKey = t11;
  const hasOrientationOption = !!orientationKey;
  let t12;
  if ($[20] !== cylindoProductConfig?.features || $[21] !== orientationKey) {
    t12 = () => {
      if (!orientationKey) {
        return;
      }
      const orientationFeature = cylindoProductConfig?.features?.find(_temp2);
      const orientationKeyStr = String(orientationKey).trim().toLowerCase();
      const orientationOption = orientationFeature?.options?.find(opt_0 => String(opt_0.code).trim().toLowerCase() === orientationKeyStr);
      if (!orientationOption) {
        return;
      }
      return {
        [CYLINDO_OPTIONS.ORIENTATION]: orientationOption.code
      };
    };
    $[20] = cylindoProductConfig?.features;
    $[21] = orientationKey;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  cylindoProductConfig?.features;
  let t13;
  if ($[23] !== t12) {
    t13 = t12();
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const orientationOptionDetails = t13;
  const isOrientationFeatureAvailable = !!orientationOptionDetails;
  const areAllFeaturesAvailable = (!hasUpholsteryOption || hasUpholsteryOption && isUpholsteryFeatureAvailable) && (!hasOrientationOption || hasOrientationOption && isOrientationFeatureAvailable);
  let t14;
  bb1: {
    if (!upholsteryFeatureDetails && !orientationOptionDetails) {
      t14 = EMPTY_OBJECT;
      break bb1;
    }
    const t15 = upholsteryFeatureDetails || EMPTY_OBJECT;
    const t16 = orientationOptionDetails || EMPTY_OBJECT;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
      t17 = {
        ...t15,
        ...t16
      };
      $[25] = t15;
      $[26] = t16;
      $[27] = t17;
    } else {
      t17 = $[27];
    }
    t14 = t17;
  }
  const cylindoFeatures = t14;
  let t15;
  bb2: {
    if (isPDPDesktop && areAllFeaturesAvailable && Object.entries(cylindoFeatures).length) {
      let t16;
      if ($[28] !== cylindoFeatures) {
        t16 = Object.entries(cylindoFeatures).map(_temp3);
        $[28] = cylindoFeatures;
        $[29] = t16;
      } else {
        t16 = $[29];
      }
      const featuresString = t16.join("&feature=");
      let t17;
      if ($[30] !== featuresString || $[31] !== productId) {
        t17 = CYLINDO_FRAMES_TO_SHOW.map((frame, index) => ({
          id: frame,
          index,
          src: `${CYLINDO_CONTENT_API}/${CYLINDO_ACCOUNT_ID}/products/${productId}/frames/${frame}?feature=${featuresString}`,
          type: "cylindo"
        }));
        $[30] = featuresString;
        $[31] = productId;
        $[32] = t17;
      } else {
        t17 = $[32];
      }
      t15 = t17;
      break bb2;
    }
    t15 = EMPTY_ARRAY;
  }
  const cylindoConfigurationPhotos = t15;
  const t16 = !!cylindoProductConfig && areAllFeaturesAvailable;
  const t17 = isCylindoProduct && !!cylindoProductConfig && areAllFeaturesAvailable && cylindoConfigurationPhotos?.length > 0;
  let t18;
  if ($[33] !== cylindoConfigurationPhotos || $[34] !== cylindoFeatures || $[35] !== dimensionShotsData || $[36] !== loading || $[37] !== t16 || $[38] !== t17 || $[39] !== upholsteryKey) {
    t18 = {
      cylindoConfigurationPhotos,
      cylindoFeatures,
      isCylindoAvailable: t16,
      loading,
      isCylindoConfigurationPhotos: t17,
      upholsteryKey,
      ...dimensionShotsData
    };
    $[33] = cylindoConfigurationPhotos;
    $[34] = cylindoFeatures;
    $[35] = dimensionShotsData;
    $[36] = loading;
    $[37] = t16;
    $[38] = t17;
    $[39] = upholsteryKey;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};
export default usePDPCylindoViewer;
function _temp(feat) {
  return feat.code === CYLINDO_OPTIONS.UPHOLSTERY;
}
function _temp2(feat_0) {
  return feat_0.code === CYLINDO_OPTIONS.ORIENTATION;
}
function _temp3(t0) {
  const [featureKey, featureCode] = t0;
  return `${featureKey}:${featureCode}`;
}